import { POST } from "./api.http.service";

export const postLoginAPI = (payload) => POST("login")(payload);
export const postForgotPasswordAPI = (payload) =>
  POST("user/forgotpwd")(payload);
